import { render, staticRenderFns } from "./B2bOrders.vue?vue&type=template&id=53700659&scoped=true&"
import script from "./B2bOrders.vue?vue&type=script&lang=js&"
export * from "./B2bOrders.vue?vue&type=script&lang=js&"
import style0 from "./B2bOrders.vue?vue&type=style&index=0&id=53700659&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53700659",
  null
  
)

export default component.exports